module.exports = __webpack_public_path__ + "static/img/plug2.8091d564.png";